<template>
  <div>
    <p class="body-1">
      {{ $t('Put this code on the pages where you want the widget to appear') }}
    </p>

    <code-block
      language="html"
      class="mb-4"
      :code="`<script
  ${useOnAllPagesScript}
></script>`"
      @copy-success="() => $root.$snack('success', 'Copied to clipboard', 1500)"
      @copy-error="() => $root.$snack('error', 'Could not copy to clipboard', 1500)"
    />
  </div>
</template>

<script>
export default {
  props: {
    faq: {
      type: Object,
      required: true,
    },
    loaderScriptUrl: {
      type: String,
      required: true
    }
  },

  computed: {
    useOnSinglePageScript() {
      return `src="${this.loaderScriptUrl}"
  data-component="webcomet-faq-widget"
  data-faq-id="${this.faq.slug}"`;
    },

    useOnAllPagesScript() {
      return `src="${this.loaderScriptUrl}"
  data-component="webcomet-faq-widget"
  data-faq-id="${this.faq.slug}"
  data-append-to-body="true"`;
    },
  },
}
</script>